/**
 * @prettier
 * THIS STORE IS AUTO-GENERATED - DO NOT MODIFY ANYTHING IN HERE!
 */
import {
  apiEffortsGetCollection,
  apiEffortsPost,
  apiEffortsIdDelete,
  apiEffortsIdGet,
  apiEffortsIdPut,
  apiEffortsIdchildrenGetCollection,
  apiEffortsLastUsedGetCollection,
  apiEffortsLostBudgetGetCollection,
  apiEffortsMyAssignmentsGetCollection,
  apiEffortsMyPriorizedGetCollection,
  apiEffortsPriorizedGetCollection,
  apiEffortsUnsyncedGetCollection,
} from "@/api";
import { useLogger, type Logger } from "@/composables/useLogger";
import { useMercure, type MercureUnsubscriber } from "@/composables/useMercure";
import { type StoreCache, useStoreCache } from "@/composables/useStoreCache";
import { fromIri, iri2id, isIri } from "@/helpers/iri";
import { useEventBus } from "@vueuse/core";
import { Semaphore } from "async-mutex";
import { keyBy, uniq, without, forEach, fromPairs } from "lodash-es";
import { AxiosResponse, AxiosError } from "axios";
import {
  checkIriArray,
  HydraToPagination,
  HydraToIriDictionary,
  HydraToIriMap,
  filterAsync,
  arrayToObject,
  RequestOptions,
  defaultRequestOptionsMerge,
  storeMethodArgumentsCompatibilityLayer,
} from "@/stores";
import { defineStore, DefineStoreOptions, StateTree, Store } from "pinia";
import type {
  ApiEffortsGetCollectionData,
  ApiEffortsGetCollectionResponse,
  ApiEffortsPostData,
  ApiEffortsPostResponse,
  ApiEffortsIdDeleteData,
  ApiEffortsIdDeleteResponse,
  ApiEffortsIdGetData,
  ApiEffortsIdGetResponse,
  ApiEffortsIdPutData,
  ApiEffortsIdPutResponse,
  ApiEffortsIdchildrenGetCollectionData,
  ApiEffortsIdchildrenGetCollectionResponse,
  ApiEffortsLastUsedGetCollectionData,
  ApiEffortsLastUsedGetCollectionResponse,
  ApiEffortsLostBudgetGetCollectionData,
  ApiEffortsLostBudgetGetCollectionResponse,
  ApiEffortsMyAssignmentsGetCollectionData,
  ApiEffortsMyAssignmentsGetCollectionResponse,
  ApiEffortsMyPriorizedGetCollectionData,
  ApiEffortsMyPriorizedGetCollectionResponse,
  ApiEffortsPriorizedGetCollectionData,
  ApiEffortsPriorizedGetCollectionResponse,
  ApiEffortsUnsyncedGetCollectionData,
  ApiEffortsUnsyncedGetCollectionResponse,
} from "@/api";

import type { Pagination, JsonldCollection } from "@/stores";

//#region Live stream handler
useEventBus("mercure-connected").on(() => {
  const mercureUnsubscriber: MercureUnsubscriber = useMercure().subscribe<{
    "@id": string;
  }>("Effort", async (data: { "@id": string }) => {
    if (data["@id"])
      await useGeneratedEffortStore().$cache.set(
        iri2id(data["@id"]),
        data,
        "item",
      );
  });
  useEventBus("mercure-disconnected").once(() => {
    // this.$logger.debug(`unsubscribed to real-time updates`);
    mercureUnsubscriber();
  });
});
//#endregion Live stream handler
const storeId = "effort-store.gen";
const logger = useLogger(storeId);
//const cache = useStoreCache(storeId)
export const useGeneratedEffortStore = defineStore(storeId, {
  state: () => ({
    loading: false,
    $iriPrefix: "/api/efforts",
    $cache: useStoreCache(storeId),
  }),
  actions: {
    /*
     * GetCnt: 1
     * CollectionCnt: 8
     * PatchCnt: 0
     * PostCnt: 1
     * PutCnt: 1
     * DeleteCnt: 1
     */

    async fetchById<ThrowGlobalError extends boolean = true>(
      id: string,
      options?: RequestOptions<ThrowGlobalError>,
    ) {
      options = storeMethodArgumentsCompatibilityLayer(arguments, "fetchBy");
      options = defaultRequestOptionsMerge(options);
      if (options?.forceRefresh)
        await this.$cache.delete(
          id + ":" + (options?.context ?? "default"),
          "item",
        );
      return await this.$cache.getOrCreate<ApiEffortsIdGetResponse>(
        id + ":" + (options?.context ?? "default"),
        async () => {
          const promise = (await apiEffortsIdGet<ThrowGlobalError>({
            ...(options?.context
              ? { query: { context: options?.context } }
              : {}),
            path: { id: id as unknown as string },
            throwOnError: options.throwGlobalError,
          })) as AxiosResponse<ApiEffortsIdGetResponse>;
          if (!(promise.status >= 200 && promise.status < 300))
            throw new Error("ERROR_SKIP_CACHE", { cause: promise });
          return promise.data;
        },
        "item",
      );
    },
    async fetchByIdRaw<ThrowGlobalError extends boolean = true>(
      id: string,
      context?: string,
    ) {
      return await apiEffortsIdGet<ThrowGlobalError>({
        ...(context ? { query: { context } } : {}),
        path: { id: id },
      });
    },

    fetchByIri<ThrowGlobalError extends boolean = true>(
      iri: string,
      options?: RequestOptions<ThrowGlobalError>,
    ) {
      options = storeMethodArgumentsCompatibilityLayer(arguments, "fetchByIri");
      options = defaultRequestOptionsMerge(options);
      if (!iri) {
        debugger;
        throw new Error("No Iri");
      }
      const id = iri2id(iri, false);
      return this.fetchById<ThrowGlobalError>(id, options);
    },

    /**
{"name":"apiEffortsGetCollection","tag":"Effort","storeName":"Effort","requestType":"ApiEffortsGetCollectionData","responseType":"ApiEffortsGetCollectionResponse","errorType":"unknown","apiFunctionName":"apiEffortsGetCollection","requestImportName":"ApiEffortsGetCollectionData","responseImportName":"ApiEffortsGetCollectionResponse","actionType":"collection","actionName":"fetchAll","friendlyName":"fetchAll","suffix":""}
*/
    async findAll<ThrowGlobalError extends boolean = true>(
      payload: ApiEffortsGetCollectionData | null,
      options?: RequestOptions<ThrowGlobalError>,
    ): Promise<Ref<ApiEffortsGetCollectionResponse["hydra:member"]>> {
      options = storeMethodArgumentsCompatibilityLayer(arguments, "findAll");
      options = defaultRequestOptionsMerge(options);
      payload ??= {};
      payload.query ??= {};
      payload.query.page ??= 1;
      payload.query.itemsPerPage ??= 100;
      if (payload.query.itemsPerPage === 0) return ref([]);
      if (options?.context) payload.query.context = options.context;
      if (options?.forceRefresh)
        await this.$cache.delete(payload, "collection");
      const res = await this.$cache.getOrCreate<
        ApiEffortsGetCollectionResponse["hydra:member"]
      >(
        payload,
        async () => {
          const promise = (await apiEffortsGetCollection<ThrowGlobalError>({
            ...payload,
            ...(options?.context
              ? { query: { context: options?.context } }
              : {}),
            throwOnError: options.throwGlobalError,
          })) as AxiosResponse<ApiEffortsGetCollectionResponse["hydra:member"]>;
          if (!(promise.status >= 200 && promise.status < 300))
            throw new Error("ERROR_SKIP_CACHE", { cause: promise });
          return promise.data["hydra:member"]
            ? Array.from(promise.data["hydra:member"])
            : [];
        },
        "collection",
      );
      if (typeof res.value === "object" && !payload.query["properties[]"]) {
        const data =
          res.value as ApiEffortsGetCollectionResponse["hydra:member"];
        await Promise.all(
          data.map((jsonld) => {
            if (jsonld["@id"]) {
              return this.$cache.set(iri2id(jsonld["@id"]), jsonld, "item");
            }
          }),
        );
      }
      return res as Ref<ApiEffortsGetCollectionResponse["hydra:member"]>;
    },
    async findAllHydra<ThrowGlobalError extends boolean = true>(
      payload: ApiEffortsGetCollectionData | null,
      options?: RequestOptions<ThrowGlobalError>,
    ): Promise<Ref<ApiEffortsGetCollectionResponse>> {
      payload ??= {};
      payload.query ??= {};
      payload.query.page ??= 1;
      payload.query.itemsPerPage ??= 100;
      if (options?.context) payload.query.context = options.context;
      if (options?.forceRefresh) await this.$cache.delete(payload, "hydra");
      const res =
        await this.$cache.getOrCreate<ApiEffortsGetCollectionResponse>(
          payload,
          async () => {
            const d = await apiEffortsGetCollection<ThrowGlobalError>(
              payload,
            ).then((d) => d.data);
            return d;
          },
          "hydra",
        );
      if (typeof res.value === "object" && !payload.query["properties[]"]) {
        const data = res.value["hydra:member"];
        await Promise.all(
          data.map((jsonld) => {
            if (jsonld["@id"]) {
              return this.$cache.set(iri2id(jsonld["@id"]), jsonld, "item");
            }
          }),
        );
      }
      return res;
    },
    async find<ThrowGlobalError extends boolean = true>(
      payload: ApiEffortsGetCollectionData,
      options?: RequestOptions<ThrowGlobalError>,
    ) {
      options = storeMethodArgumentsCompatibilityLayer(arguments, "find");
      if (!payload) payload = { query: {} };
      if (!payload.query) payload.query = {};
      payload.query.page = 1;
      payload.query.itemsPerPage = 1;
      if (options?.context) payload.query.context = options.context;
      const res = await this.findAll<ThrowGlobalError>(payload, options);
      if (res.value.length > 1)
        logger.warn("Find() returned more than one result!");
      return computed(() => (res.value.length > 0 ? res.value[0] : undefined));
    },
    /* {"name":"apiEffortsGetCollection","tag":"Effort","storeName":"Effort","requestType":"ApiEffortsGetCollectionData","responseType":"ApiEffortsGetCollectionResponse","errorType":"unknown","apiFunctionName":"apiEffortsGetCollection","requestImportName":"ApiEffortsGetCollectionData","responseImportName":"ApiEffortsGetCollectionResponse","actionType":"collection","actionName":"fetchAll","friendlyName":"fetchAll","suffix":""} */
    async findAllWithPagination<ThrowGlobalError extends boolean = true>(
      payload: ApiEffortsGetCollectionData | null,
      options?: RequestOptions<ThrowGlobalError>,
    ) {
      options = storeMethodArgumentsCompatibilityLayer(
        arguments,
        "findAllWithPagination",
      );
      const result = await this.findAllHydra<ThrowGlobalError>(
        payload,
        options,
      );
      return HydraToPagination<(typeof result.value)["hydra:member"][number]>(
        result,
      );
    },
    async findAllAsIriDictionary<ThrowGlobalError extends boolean = true>(
      payload: ApiEffortsGetCollectionData | null,
      options?: RequestOptions<ThrowGlobalError>,
    ) {
      options = storeMethodArgumentsCompatibilityLayer(
        arguments,
        "findAllAsIriDictionary",
      );
      const result = await this.findAllHydra<ThrowGlobalError>(
        payload,
        options,
      );
      return HydraToIriDictionary<
        (typeof result.value)["hydra:member"][number]
      >(result);
    },
    async findAllAsMap<ThrowGlobalError extends boolean = true>(
      payload: ApiEffortsGetCollectionData | null,
      options?: RequestOptions<ThrowGlobalError>,
    ) {
      options = storeMethodArgumentsCompatibilityLayer(
        arguments,
        "findAllAsMap",
      );
      const result = await this.findAllHydra<ThrowGlobalError>(
        payload,
        options,
      );
      return HydraToIriMap<(typeof result.value)["hydra:member"][number]>(
        result,
      );
    },
    /**
{"name":"apiEffortsIdchildrenGetCollection","tag":"Effort","storeName":"Effort","requestType":"ApiEffortsIdchildrenGetCollectionData","responseType":"ApiEffortsIdchildrenGetCollectionResponse","errorType":"unknown","apiFunctionName":"apiEffortsIdchildrenGetCollection","requestImportName":"ApiEffortsIdchildrenGetCollectionData","responseImportName":"ApiEffortsIdchildrenGetCollectionResponse","actionType":"collection","actionName":"fetchAll","friendlyName":"fetchAll","identifierName":"id","identifierType":"string","suffix":"Idchildren","identifierNameCapitalized":"Id"}
*/
    async findAllIdchildren<ThrowGlobalError extends boolean = true>(
      payload: ApiEffortsIdchildrenGetCollectionData | null,
      options?: RequestOptions<ThrowGlobalError>,
    ): Promise<Ref<ApiEffortsIdchildrenGetCollectionResponse["hydra:member"]>> {
      options = storeMethodArgumentsCompatibilityLayer(arguments, "findAll");
      options = defaultRequestOptionsMerge(options);
      payload ??= {};
      payload.query ??= {};
      payload.query.page ??= 1;
      payload.query.itemsPerPage ??= 100;
      if (payload.query.itemsPerPage === 0) return ref([]);
      if (options?.context) payload.query.context = options.context;
      if (options?.forceRefresh)
        await this.$cache.delete(payload, "collection");
      const res = await this.$cache.getOrCreate<
        ApiEffortsIdchildrenGetCollectionResponse["hydra:member"]
      >(
        payload,
        async () => {
          const promise =
            (await apiEffortsIdchildrenGetCollection<ThrowGlobalError>({
              ...payload,
              ...(options?.context
                ? { query: { context: options?.context } }
                : {}),
              throwOnError: options.throwGlobalError,
            })) as AxiosResponse<
              ApiEffortsIdchildrenGetCollectionResponse["hydra:member"]
            >;
          if (!(promise.status >= 200 && promise.status < 300))
            throw new Error("ERROR_SKIP_CACHE", { cause: promise });
          return promise.data["hydra:member"]
            ? Array.from(promise.data["hydra:member"])
            : [];
        },
        "collection",
      );
      if (typeof res.value === "object" && !payload.query["properties[]"]) {
        const data =
          res.value as ApiEffortsIdchildrenGetCollectionResponse["hydra:member"];
        await Promise.all(
          data.map((jsonld) => {
            if (jsonld["@id"]) {
              return this.$cache.set(iri2id(jsonld["@id"]), jsonld, "item");
            }
          }),
        );
      }
      return res as Ref<
        ApiEffortsIdchildrenGetCollectionResponse["hydra:member"]
      >;
    },
    async findAllIdchildrenHydra<ThrowGlobalError extends boolean = true>(
      payload: ApiEffortsIdchildrenGetCollectionData | null,
      options?: RequestOptions<ThrowGlobalError>,
    ): Promise<Ref<ApiEffortsIdchildrenGetCollectionResponse>> {
      payload ??= {};
      payload.query ??= {};
      payload.query.page ??= 1;
      payload.query.itemsPerPage ??= 100;
      if (options?.context) payload.query.context = options.context;
      if (options?.forceRefresh) await this.$cache.delete(payload, "hydra");
      const res =
        await this.$cache.getOrCreate<ApiEffortsIdchildrenGetCollectionResponse>(
          payload,
          async () => {
            const d = await apiEffortsIdchildrenGetCollection<ThrowGlobalError>(
              payload,
            ).then((d) => d.data);
            return d;
          },
          "hydra",
        );
      if (typeof res.value === "object" && !payload.query["properties[]"]) {
        const data = res.value["hydra:member"];
        await Promise.all(
          data.map((jsonld) => {
            if (jsonld["@id"]) {
              return this.$cache.set(iri2id(jsonld["@id"]), jsonld, "item");
            }
          }),
        );
      }
      return res;
    },
    async findIdchildren<ThrowGlobalError extends boolean = true>(
      payload: ApiEffortsIdchildrenGetCollectionData,
      options?: RequestOptions<ThrowGlobalError>,
    ) {
      options = storeMethodArgumentsCompatibilityLayer(arguments, "find");
      if (!payload) payload = { query: {} };
      if (!payload.query) payload.query = {};
      payload.query.page = 1;
      payload.query.itemsPerPage = 1;
      if (options?.context) payload.query.context = options.context;
      const res = await this.findAll<ThrowGlobalError>(payload, options);
      if (res.value.length > 1)
        logger.warn("Find() returned more than one result!");
      return computed(() => (res.value.length > 0 ? res.value[0] : undefined));
    },
    /* {"name":"apiEffortsIdchildrenGetCollection","tag":"Effort","storeName":"Effort","requestType":"ApiEffortsIdchildrenGetCollectionData","responseType":"ApiEffortsIdchildrenGetCollectionResponse","errorType":"unknown","apiFunctionName":"apiEffortsIdchildrenGetCollection","requestImportName":"ApiEffortsIdchildrenGetCollectionData","responseImportName":"ApiEffortsIdchildrenGetCollectionResponse","actionType":"collection","actionName":"fetchAll","friendlyName":"fetchAll","identifierName":"id","identifierType":"string","suffix":"Idchildren","identifierNameCapitalized":"Id"} */
    async findAllIdchildrenWithPagination<
      ThrowGlobalError extends boolean = true,
    >(
      payload: ApiEffortsIdchildrenGetCollectionData | null,
      options?: RequestOptions<ThrowGlobalError>,
    ) {
      options = storeMethodArgumentsCompatibilityLayer(
        arguments,
        "findAllWithPagination",
      );
      const result = await this.findAllIdchildrenHydra<ThrowGlobalError>(
        payload,
        options,
      );
      return HydraToPagination<(typeof result.value)["hydra:member"][number]>(
        result,
      );
    },
    async findAllIdchildrenAsIriDictionary<
      ThrowGlobalError extends boolean = true,
    >(
      payload: ApiEffortsIdchildrenGetCollectionData | null,
      options?: RequestOptions<ThrowGlobalError>,
    ) {
      options = storeMethodArgumentsCompatibilityLayer(
        arguments,
        "findAllAsIriDictionary",
      );
      const result = await this.findAllIdchildrenHydra<ThrowGlobalError>(
        payload,
        options,
      );
      return HydraToIriDictionary<
        (typeof result.value)["hydra:member"][number]
      >(result);
    },
    async findAllIdchildrenAsMap<ThrowGlobalError extends boolean = true>(
      payload: ApiEffortsIdchildrenGetCollectionData | null,
      options?: RequestOptions<ThrowGlobalError>,
    ) {
      options = storeMethodArgumentsCompatibilityLayer(
        arguments,
        "findAllAsMap",
      );
      const result = await this.findAllIdchildrenHydra<ThrowGlobalError>(
        payload,
        options,
      );
      return HydraToIriMap<(typeof result.value)["hydra:member"][number]>(
        result,
      );
    },
    /**
{"name":"apiEffortsLastUsedGetCollection","tag":"Effort","storeName":"Effort","requestType":"ApiEffortsLastUsedGetCollectionData","responseType":"ApiEffortsLastUsedGetCollectionResponse","errorType":"unknown","apiFunctionName":"apiEffortsLastUsedGetCollection","requestImportName":"ApiEffortsLastUsedGetCollectionData","responseImportName":"ApiEffortsLastUsedGetCollectionResponse","actionType":"collection","actionName":"fetchAll","friendlyName":"fetchAll","suffix":"LastUsed"}
*/
    async findAllLastUsed<ThrowGlobalError extends boolean = true>(
      payload: ApiEffortsLastUsedGetCollectionData | null,
      options?: RequestOptions<ThrowGlobalError>,
    ): Promise<Ref<ApiEffortsLastUsedGetCollectionResponse["hydra:member"]>> {
      options = storeMethodArgumentsCompatibilityLayer(arguments, "findAll");
      options = defaultRequestOptionsMerge(options);
      payload ??= {};
      payload.query ??= {};
      payload.query.page ??= 1;
      payload.query.itemsPerPage ??= 100;
      if (payload.query.itemsPerPage === 0) return ref([]);
      if (options?.context) payload.query.context = options.context;
      if (options?.forceRefresh)
        await this.$cache.delete(payload, "collection");
      const res = await this.$cache.getOrCreate<
        ApiEffortsLastUsedGetCollectionResponse["hydra:member"]
      >(
        payload,
        async () => {
          const promise =
            (await apiEffortsLastUsedGetCollection<ThrowGlobalError>({
              ...payload,
              ...(options?.context
                ? { query: { context: options?.context } }
                : {}),
              throwOnError: options.throwGlobalError,
            })) as AxiosResponse<
              ApiEffortsLastUsedGetCollectionResponse["hydra:member"]
            >;
          if (!(promise.status >= 200 && promise.status < 300))
            throw new Error("ERROR_SKIP_CACHE", { cause: promise });
          return promise.data["hydra:member"]
            ? Array.from(promise.data["hydra:member"])
            : [];
        },
        "collection",
      );
      if (typeof res.value === "object" && !payload.query["properties[]"]) {
        const data =
          res.value as ApiEffortsLastUsedGetCollectionResponse["hydra:member"];
        await Promise.all(
          data.map((jsonld) => {
            if (jsonld["@id"]) {
              return this.$cache.set(iri2id(jsonld["@id"]), jsonld, "item");
            }
          }),
        );
      }
      return res as Ref<
        ApiEffortsLastUsedGetCollectionResponse["hydra:member"]
      >;
    },
    async findAllLastUsedHydra<ThrowGlobalError extends boolean = true>(
      payload: ApiEffortsLastUsedGetCollectionData | null,
      options?: RequestOptions<ThrowGlobalError>,
    ): Promise<Ref<ApiEffortsLastUsedGetCollectionResponse>> {
      payload ??= {};
      payload.query ??= {};
      payload.query.page ??= 1;
      payload.query.itemsPerPage ??= 100;
      if (options?.context) payload.query.context = options.context;
      if (options?.forceRefresh) await this.$cache.delete(payload, "hydra");
      const res =
        await this.$cache.getOrCreate<ApiEffortsLastUsedGetCollectionResponse>(
          payload,
          async () => {
            const d = await apiEffortsLastUsedGetCollection<ThrowGlobalError>(
              payload,
            ).then((d) => d.data);
            return d;
          },
          "hydra",
        );
      if (typeof res.value === "object" && !payload.query["properties[]"]) {
        const data = res.value["hydra:member"];
        await Promise.all(
          data.map((jsonld) => {
            if (jsonld["@id"]) {
              return this.$cache.set(iri2id(jsonld["@id"]), jsonld, "item");
            }
          }),
        );
      }
      return res;
    },
    async findLastUsed<ThrowGlobalError extends boolean = true>(
      payload: ApiEffortsLastUsedGetCollectionData,
      options?: RequestOptions<ThrowGlobalError>,
    ) {
      options = storeMethodArgumentsCompatibilityLayer(arguments, "find");
      if (!payload) payload = { query: {} };
      if (!payload.query) payload.query = {};
      payload.query.page = 1;
      payload.query.itemsPerPage = 1;
      if (options?.context) payload.query.context = options.context;
      const res = await this.findAll<ThrowGlobalError>(payload, options);
      if (res.value.length > 1)
        logger.warn("Find() returned more than one result!");
      return computed(() => (res.value.length > 0 ? res.value[0] : undefined));
    },
    /* {"name":"apiEffortsLastUsedGetCollection","tag":"Effort","storeName":"Effort","requestType":"ApiEffortsLastUsedGetCollectionData","responseType":"ApiEffortsLastUsedGetCollectionResponse","errorType":"unknown","apiFunctionName":"apiEffortsLastUsedGetCollection","requestImportName":"ApiEffortsLastUsedGetCollectionData","responseImportName":"ApiEffortsLastUsedGetCollectionResponse","actionType":"collection","actionName":"fetchAll","friendlyName":"fetchAll","suffix":"LastUsed"} */
    async findAllLastUsedWithPagination<
      ThrowGlobalError extends boolean = true,
    >(
      payload: ApiEffortsLastUsedGetCollectionData | null,
      options?: RequestOptions<ThrowGlobalError>,
    ) {
      options = storeMethodArgumentsCompatibilityLayer(
        arguments,
        "findAllWithPagination",
      );
      const result = await this.findAllLastUsedHydra<ThrowGlobalError>(
        payload,
        options,
      );
      return HydraToPagination<(typeof result.value)["hydra:member"][number]>(
        result,
      );
    },
    async findAllLastUsedAsIriDictionary<
      ThrowGlobalError extends boolean = true,
    >(
      payload: ApiEffortsLastUsedGetCollectionData | null,
      options?: RequestOptions<ThrowGlobalError>,
    ) {
      options = storeMethodArgumentsCompatibilityLayer(
        arguments,
        "findAllAsIriDictionary",
      );
      const result = await this.findAllLastUsedHydra<ThrowGlobalError>(
        payload,
        options,
      );
      return HydraToIriDictionary<
        (typeof result.value)["hydra:member"][number]
      >(result);
    },
    async findAllLastUsedAsMap<ThrowGlobalError extends boolean = true>(
      payload: ApiEffortsLastUsedGetCollectionData | null,
      options?: RequestOptions<ThrowGlobalError>,
    ) {
      options = storeMethodArgumentsCompatibilityLayer(
        arguments,
        "findAllAsMap",
      );
      const result = await this.findAllLastUsedHydra<ThrowGlobalError>(
        payload,
        options,
      );
      return HydraToIriMap<(typeof result.value)["hydra:member"][number]>(
        result,
      );
    },
    /**
{"name":"apiEffortsLostBudgetGetCollection","tag":"Effort","storeName":"Effort","requestType":"ApiEffortsLostBudgetGetCollectionData","responseType":"ApiEffortsLostBudgetGetCollectionResponse","errorType":"unknown","apiFunctionName":"apiEffortsLostBudgetGetCollection","requestImportName":"ApiEffortsLostBudgetGetCollectionData","responseImportName":"ApiEffortsLostBudgetGetCollectionResponse","actionType":"collection","actionName":"fetchAll","friendlyName":"fetchAll","suffix":"LostBudget"}
*/
    async findAllLostBudget<ThrowGlobalError extends boolean = true>(
      payload: ApiEffortsLostBudgetGetCollectionData | null,
      options?: RequestOptions<ThrowGlobalError>,
    ): Promise<Ref<ApiEffortsLostBudgetGetCollectionResponse["hydra:member"]>> {
      options = storeMethodArgumentsCompatibilityLayer(arguments, "findAll");
      options = defaultRequestOptionsMerge(options);
      payload ??= {};
      payload.query ??= {};
      payload.query.page ??= 1;
      payload.query.itemsPerPage ??= 100;
      if (payload.query.itemsPerPage === 0) return ref([]);
      if (options?.context) payload.query.context = options.context;
      if (options?.forceRefresh)
        await this.$cache.delete(payload, "collection");
      const res = await this.$cache.getOrCreate<
        ApiEffortsLostBudgetGetCollectionResponse["hydra:member"]
      >(
        payload,
        async () => {
          const promise =
            (await apiEffortsLostBudgetGetCollection<ThrowGlobalError>({
              ...payload,
              ...(options?.context
                ? { query: { context: options?.context } }
                : {}),
              throwOnError: options.throwGlobalError,
            })) as AxiosResponse<
              ApiEffortsLostBudgetGetCollectionResponse["hydra:member"]
            >;
          if (!(promise.status >= 200 && promise.status < 300))
            throw new Error("ERROR_SKIP_CACHE", { cause: promise });
          return promise.data["hydra:member"]
            ? Array.from(promise.data["hydra:member"])
            : [];
        },
        "collection",
      );
      if (typeof res.value === "object" && !payload.query["properties[]"]) {
        const data =
          res.value as ApiEffortsLostBudgetGetCollectionResponse["hydra:member"];
        await Promise.all(
          data.map((jsonld) => {
            if (jsonld["@id"]) {
              return this.$cache.set(iri2id(jsonld["@id"]), jsonld, "item");
            }
          }),
        );
      }
      return res as Ref<
        ApiEffortsLostBudgetGetCollectionResponse["hydra:member"]
      >;
    },
    async findAllLostBudgetHydra<ThrowGlobalError extends boolean = true>(
      payload: ApiEffortsLostBudgetGetCollectionData | null,
      options?: RequestOptions<ThrowGlobalError>,
    ): Promise<Ref<ApiEffortsLostBudgetGetCollectionResponse>> {
      payload ??= {};
      payload.query ??= {};
      payload.query.page ??= 1;
      payload.query.itemsPerPage ??= 100;
      if (options?.context) payload.query.context = options.context;
      if (options?.forceRefresh) await this.$cache.delete(payload, "hydra");
      const res =
        await this.$cache.getOrCreate<ApiEffortsLostBudgetGetCollectionResponse>(
          payload,
          async () => {
            const d = await apiEffortsLostBudgetGetCollection<ThrowGlobalError>(
              payload,
            ).then((d) => d.data);
            return d;
          },
          "hydra",
        );
      if (typeof res.value === "object" && !payload.query["properties[]"]) {
        const data = res.value["hydra:member"];
        await Promise.all(
          data.map((jsonld) => {
            if (jsonld["@id"]) {
              return this.$cache.set(iri2id(jsonld["@id"]), jsonld, "item");
            }
          }),
        );
      }
      return res;
    },
    async findLostBudget<ThrowGlobalError extends boolean = true>(
      payload: ApiEffortsLostBudgetGetCollectionData,
      options?: RequestOptions<ThrowGlobalError>,
    ) {
      options = storeMethodArgumentsCompatibilityLayer(arguments, "find");
      if (!payload) payload = { query: {} };
      if (!payload.query) payload.query = {};
      payload.query.page = 1;
      payload.query.itemsPerPage = 1;
      if (options?.context) payload.query.context = options.context;
      const res = await this.findAll<ThrowGlobalError>(payload, options);
      if (res.value.length > 1)
        logger.warn("Find() returned more than one result!");
      return computed(() => (res.value.length > 0 ? res.value[0] : undefined));
    },
    /* {"name":"apiEffortsLostBudgetGetCollection","tag":"Effort","storeName":"Effort","requestType":"ApiEffortsLostBudgetGetCollectionData","responseType":"ApiEffortsLostBudgetGetCollectionResponse","errorType":"unknown","apiFunctionName":"apiEffortsLostBudgetGetCollection","requestImportName":"ApiEffortsLostBudgetGetCollectionData","responseImportName":"ApiEffortsLostBudgetGetCollectionResponse","actionType":"collection","actionName":"fetchAll","friendlyName":"fetchAll","suffix":"LostBudget"} */
    async findAllLostBudgetWithPagination<
      ThrowGlobalError extends boolean = true,
    >(
      payload: ApiEffortsLostBudgetGetCollectionData | null,
      options?: RequestOptions<ThrowGlobalError>,
    ) {
      options = storeMethodArgumentsCompatibilityLayer(
        arguments,
        "findAllWithPagination",
      );
      const result = await this.findAllLostBudgetHydra<ThrowGlobalError>(
        payload,
        options,
      );
      return HydraToPagination<(typeof result.value)["hydra:member"][number]>(
        result,
      );
    },
    async findAllLostBudgetAsIriDictionary<
      ThrowGlobalError extends boolean = true,
    >(
      payload: ApiEffortsLostBudgetGetCollectionData | null,
      options?: RequestOptions<ThrowGlobalError>,
    ) {
      options = storeMethodArgumentsCompatibilityLayer(
        arguments,
        "findAllAsIriDictionary",
      );
      const result = await this.findAllLostBudgetHydra<ThrowGlobalError>(
        payload,
        options,
      );
      return HydraToIriDictionary<
        (typeof result.value)["hydra:member"][number]
      >(result);
    },
    async findAllLostBudgetAsMap<ThrowGlobalError extends boolean = true>(
      payload: ApiEffortsLostBudgetGetCollectionData | null,
      options?: RequestOptions<ThrowGlobalError>,
    ) {
      options = storeMethodArgumentsCompatibilityLayer(
        arguments,
        "findAllAsMap",
      );
      const result = await this.findAllLostBudgetHydra<ThrowGlobalError>(
        payload,
        options,
      );
      return HydraToIriMap<(typeof result.value)["hydra:member"][number]>(
        result,
      );
    },
    /**
{"name":"apiEffortsMyAssignmentsGetCollection","tag":"Effort","storeName":"Effort","requestType":"ApiEffortsMyAssignmentsGetCollectionData","responseType":"ApiEffortsMyAssignmentsGetCollectionResponse","errorType":"unknown","apiFunctionName":"apiEffortsMyAssignmentsGetCollection","requestImportName":"ApiEffortsMyAssignmentsGetCollectionData","responseImportName":"ApiEffortsMyAssignmentsGetCollectionResponse","actionType":"collection","actionName":"fetchAll","friendlyName":"fetchAll","suffix":"MyAssignments"}
*/
    async findAllMyAssignments<ThrowGlobalError extends boolean = true>(
      payload: ApiEffortsMyAssignmentsGetCollectionData | null,
      options?: RequestOptions<ThrowGlobalError>,
    ): Promise<
      Ref<ApiEffortsMyAssignmentsGetCollectionResponse["hydra:member"]>
    > {
      options = storeMethodArgumentsCompatibilityLayer(arguments, "findAll");
      options = defaultRequestOptionsMerge(options);
      payload ??= {};
      payload.query ??= {};
      payload.query.page ??= 1;
      payload.query.itemsPerPage ??= 100;
      if (payload.query.itemsPerPage === 0) return ref([]);
      if (options?.context) payload.query.context = options.context;
      if (options?.forceRefresh)
        await this.$cache.delete(payload, "collection");
      const res = await this.$cache.getOrCreate<
        ApiEffortsMyAssignmentsGetCollectionResponse["hydra:member"]
      >(
        payload,
        async () => {
          const promise =
            (await apiEffortsMyAssignmentsGetCollection<ThrowGlobalError>({
              ...payload,
              ...(options?.context
                ? { query: { context: options?.context } }
                : {}),
              throwOnError: options.throwGlobalError,
            })) as AxiosResponse<
              ApiEffortsMyAssignmentsGetCollectionResponse["hydra:member"]
            >;
          if (!(promise.status >= 200 && promise.status < 300))
            throw new Error("ERROR_SKIP_CACHE", { cause: promise });
          return promise.data["hydra:member"]
            ? Array.from(promise.data["hydra:member"])
            : [];
        },
        "collection",
      );
      if (typeof res.value === "object" && !payload.query["properties[]"]) {
        const data =
          res.value as ApiEffortsMyAssignmentsGetCollectionResponse["hydra:member"];
        await Promise.all(
          data.map((jsonld) => {
            if (jsonld["@id"]) {
              return this.$cache.set(iri2id(jsonld["@id"]), jsonld, "item");
            }
          }),
        );
      }
      return res as Ref<
        ApiEffortsMyAssignmentsGetCollectionResponse["hydra:member"]
      >;
    },
    async findAllMyAssignmentsHydra<ThrowGlobalError extends boolean = true>(
      payload: ApiEffortsMyAssignmentsGetCollectionData | null,
      options?: RequestOptions<ThrowGlobalError>,
    ): Promise<Ref<ApiEffortsMyAssignmentsGetCollectionResponse>> {
      payload ??= {};
      payload.query ??= {};
      payload.query.page ??= 1;
      payload.query.itemsPerPage ??= 100;
      if (options?.context) payload.query.context = options.context;
      if (options?.forceRefresh) await this.$cache.delete(payload, "hydra");
      const res =
        await this.$cache.getOrCreate<ApiEffortsMyAssignmentsGetCollectionResponse>(
          payload,
          async () => {
            const d =
              await apiEffortsMyAssignmentsGetCollection<ThrowGlobalError>(
                payload,
              ).then((d) => d.data);
            return d;
          },
          "hydra",
        );
      if (typeof res.value === "object" && !payload.query["properties[]"]) {
        const data = res.value["hydra:member"];
        await Promise.all(
          data.map((jsonld) => {
            if (jsonld["@id"]) {
              return this.$cache.set(iri2id(jsonld["@id"]), jsonld, "item");
            }
          }),
        );
      }
      return res;
    },
    async findMyAssignments<ThrowGlobalError extends boolean = true>(
      payload: ApiEffortsMyAssignmentsGetCollectionData,
      options?: RequestOptions<ThrowGlobalError>,
    ) {
      options = storeMethodArgumentsCompatibilityLayer(arguments, "find");
      if (!payload) payload = { query: {} };
      if (!payload.query) payload.query = {};
      payload.query.page = 1;
      payload.query.itemsPerPage = 1;
      if (options?.context) payload.query.context = options.context;
      const res = await this.findAll<ThrowGlobalError>(payload, options);
      if (res.value.length > 1)
        logger.warn("Find() returned more than one result!");
      return computed(() => (res.value.length > 0 ? res.value[0] : undefined));
    },
    /* {"name":"apiEffortsMyAssignmentsGetCollection","tag":"Effort","storeName":"Effort","requestType":"ApiEffortsMyAssignmentsGetCollectionData","responseType":"ApiEffortsMyAssignmentsGetCollectionResponse","errorType":"unknown","apiFunctionName":"apiEffortsMyAssignmentsGetCollection","requestImportName":"ApiEffortsMyAssignmentsGetCollectionData","responseImportName":"ApiEffortsMyAssignmentsGetCollectionResponse","actionType":"collection","actionName":"fetchAll","friendlyName":"fetchAll","suffix":"MyAssignments"} */
    async findAllMyAssignmentsWithPagination<
      ThrowGlobalError extends boolean = true,
    >(
      payload: ApiEffortsMyAssignmentsGetCollectionData | null,
      options?: RequestOptions<ThrowGlobalError>,
    ) {
      options = storeMethodArgumentsCompatibilityLayer(
        arguments,
        "findAllWithPagination",
      );
      const result = await this.findAllMyAssignmentsHydra<ThrowGlobalError>(
        payload,
        options,
      );
      return HydraToPagination<(typeof result.value)["hydra:member"][number]>(
        result,
      );
    },
    async findAllMyAssignmentsAsIriDictionary<
      ThrowGlobalError extends boolean = true,
    >(
      payload: ApiEffortsMyAssignmentsGetCollectionData | null,
      options?: RequestOptions<ThrowGlobalError>,
    ) {
      options = storeMethodArgumentsCompatibilityLayer(
        arguments,
        "findAllAsIriDictionary",
      );
      const result = await this.findAllMyAssignmentsHydra<ThrowGlobalError>(
        payload,
        options,
      );
      return HydraToIriDictionary<
        (typeof result.value)["hydra:member"][number]
      >(result);
    },
    async findAllMyAssignmentsAsMap<ThrowGlobalError extends boolean = true>(
      payload: ApiEffortsMyAssignmentsGetCollectionData | null,
      options?: RequestOptions<ThrowGlobalError>,
    ) {
      options = storeMethodArgumentsCompatibilityLayer(
        arguments,
        "findAllAsMap",
      );
      const result = await this.findAllMyAssignmentsHydra<ThrowGlobalError>(
        payload,
        options,
      );
      return HydraToIriMap<(typeof result.value)["hydra:member"][number]>(
        result,
      );
    },
    /**
{"name":"apiEffortsMyPriorizedGetCollection","tag":"Effort","storeName":"Effort","requestType":"ApiEffortsMyPriorizedGetCollectionData","responseType":"ApiEffortsMyPriorizedGetCollectionResponse","errorType":"unknown","apiFunctionName":"apiEffortsMyPriorizedGetCollection","requestImportName":"ApiEffortsMyPriorizedGetCollectionData","responseImportName":"ApiEffortsMyPriorizedGetCollectionResponse","actionType":"collection","actionName":"fetchAll","friendlyName":"fetchAll","suffix":"MyPriorized"}
*/
    async findAllMyPriorized<ThrowGlobalError extends boolean = true>(
      payload: ApiEffortsMyPriorizedGetCollectionData | null,
      options?: RequestOptions<ThrowGlobalError>,
    ): Promise<
      Ref<ApiEffortsMyPriorizedGetCollectionResponse["hydra:member"]>
    > {
      options = storeMethodArgumentsCompatibilityLayer(arguments, "findAll");
      options = defaultRequestOptionsMerge(options);
      payload ??= {};
      payload.query ??= {};
      payload.query.page ??= 1;
      payload.query.itemsPerPage ??= 100;
      if (payload.query.itemsPerPage === 0) return ref([]);
      if (options?.context) payload.query.context = options.context;
      if (options?.forceRefresh)
        await this.$cache.delete(payload, "collection");
      const res = await this.$cache.getOrCreate<
        ApiEffortsMyPriorizedGetCollectionResponse["hydra:member"]
      >(
        payload,
        async () => {
          const promise =
            (await apiEffortsMyPriorizedGetCollection<ThrowGlobalError>({
              ...payload,
              ...(options?.context
                ? { query: { context: options?.context } }
                : {}),
              throwOnError: options.throwGlobalError,
            })) as AxiosResponse<
              ApiEffortsMyPriorizedGetCollectionResponse["hydra:member"]
            >;
          if (!(promise.status >= 200 && promise.status < 300))
            throw new Error("ERROR_SKIP_CACHE", { cause: promise });
          return promise.data["hydra:member"]
            ? Array.from(promise.data["hydra:member"])
            : [];
        },
        "collection",
      );
      if (typeof res.value === "object" && !payload.query["properties[]"]) {
        const data =
          res.value as ApiEffortsMyPriorizedGetCollectionResponse["hydra:member"];
        await Promise.all(
          data.map((jsonld) => {
            if (jsonld["@id"]) {
              return this.$cache.set(iri2id(jsonld["@id"]), jsonld, "item");
            }
          }),
        );
      }
      return res as Ref<
        ApiEffortsMyPriorizedGetCollectionResponse["hydra:member"]
      >;
    },
    async findAllMyPriorizedHydra<ThrowGlobalError extends boolean = true>(
      payload: ApiEffortsMyPriorizedGetCollectionData | null,
      options?: RequestOptions<ThrowGlobalError>,
    ): Promise<Ref<ApiEffortsMyPriorizedGetCollectionResponse>> {
      payload ??= {};
      payload.query ??= {};
      payload.query.page ??= 1;
      payload.query.itemsPerPage ??= 100;
      if (options?.context) payload.query.context = options.context;
      if (options?.forceRefresh) await this.$cache.delete(payload, "hydra");
      const res =
        await this.$cache.getOrCreate<ApiEffortsMyPriorizedGetCollectionResponse>(
          payload,
          async () => {
            const d =
              await apiEffortsMyPriorizedGetCollection<ThrowGlobalError>(
                payload,
              ).then((d) => d.data);
            return d;
          },
          "hydra",
        );
      if (typeof res.value === "object" && !payload.query["properties[]"]) {
        const data = res.value["hydra:member"];
        await Promise.all(
          data.map((jsonld) => {
            if (jsonld["@id"]) {
              return this.$cache.set(iri2id(jsonld["@id"]), jsonld, "item");
            }
          }),
        );
      }
      return res;
    },
    async findMyPriorized<ThrowGlobalError extends boolean = true>(
      payload: ApiEffortsMyPriorizedGetCollectionData,
      options?: RequestOptions<ThrowGlobalError>,
    ) {
      options = storeMethodArgumentsCompatibilityLayer(arguments, "find");
      if (!payload) payload = { query: {} };
      if (!payload.query) payload.query = {};
      payload.query.page = 1;
      payload.query.itemsPerPage = 1;
      if (options?.context) payload.query.context = options.context;
      const res = await this.findAll<ThrowGlobalError>(payload, options);
      if (res.value.length > 1)
        logger.warn("Find() returned more than one result!");
      return computed(() => (res.value.length > 0 ? res.value[0] : undefined));
    },
    /* {"name":"apiEffortsMyPriorizedGetCollection","tag":"Effort","storeName":"Effort","requestType":"ApiEffortsMyPriorizedGetCollectionData","responseType":"ApiEffortsMyPriorizedGetCollectionResponse","errorType":"unknown","apiFunctionName":"apiEffortsMyPriorizedGetCollection","requestImportName":"ApiEffortsMyPriorizedGetCollectionData","responseImportName":"ApiEffortsMyPriorizedGetCollectionResponse","actionType":"collection","actionName":"fetchAll","friendlyName":"fetchAll","suffix":"MyPriorized"} */
    async findAllMyPriorizedWithPagination<
      ThrowGlobalError extends boolean = true,
    >(
      payload: ApiEffortsMyPriorizedGetCollectionData | null,
      options?: RequestOptions<ThrowGlobalError>,
    ) {
      options = storeMethodArgumentsCompatibilityLayer(
        arguments,
        "findAllWithPagination",
      );
      const result = await this.findAllMyPriorizedHydra<ThrowGlobalError>(
        payload,
        options,
      );
      return HydraToPagination<(typeof result.value)["hydra:member"][number]>(
        result,
      );
    },
    async findAllMyPriorizedAsIriDictionary<
      ThrowGlobalError extends boolean = true,
    >(
      payload: ApiEffortsMyPriorizedGetCollectionData | null,
      options?: RequestOptions<ThrowGlobalError>,
    ) {
      options = storeMethodArgumentsCompatibilityLayer(
        arguments,
        "findAllAsIriDictionary",
      );
      const result = await this.findAllMyPriorizedHydra<ThrowGlobalError>(
        payload,
        options,
      );
      return HydraToIriDictionary<
        (typeof result.value)["hydra:member"][number]
      >(result);
    },
    async findAllMyPriorizedAsMap<ThrowGlobalError extends boolean = true>(
      payload: ApiEffortsMyPriorizedGetCollectionData | null,
      options?: RequestOptions<ThrowGlobalError>,
    ) {
      options = storeMethodArgumentsCompatibilityLayer(
        arguments,
        "findAllAsMap",
      );
      const result = await this.findAllMyPriorizedHydra<ThrowGlobalError>(
        payload,
        options,
      );
      return HydraToIriMap<(typeof result.value)["hydra:member"][number]>(
        result,
      );
    },
    /**
{"name":"apiEffortsPriorizedGetCollection","tag":"Effort","storeName":"Effort","requestType":"ApiEffortsPriorizedGetCollectionData","responseType":"ApiEffortsPriorizedGetCollectionResponse","errorType":"unknown","apiFunctionName":"apiEffortsPriorizedGetCollection","requestImportName":"ApiEffortsPriorizedGetCollectionData","responseImportName":"ApiEffortsPriorizedGetCollectionResponse","actionType":"collection","actionName":"fetchAll","friendlyName":"fetchAll","suffix":"Priorized"}
*/
    async findAllPriorized<ThrowGlobalError extends boolean = true>(
      payload: ApiEffortsPriorizedGetCollectionData | null,
      options?: RequestOptions<ThrowGlobalError>,
    ): Promise<Ref<ApiEffortsPriorizedGetCollectionResponse["hydra:member"]>> {
      options = storeMethodArgumentsCompatibilityLayer(arguments, "findAll");
      options = defaultRequestOptionsMerge(options);
      payload ??= {};
      payload.query ??= {};
      payload.query.page ??= 1;
      payload.query.itemsPerPage ??= 100;
      if (payload.query.itemsPerPage === 0) return ref([]);
      if (options?.context) payload.query.context = options.context;
      if (options?.forceRefresh)
        await this.$cache.delete(payload, "collection");
      const res = await this.$cache.getOrCreate<
        ApiEffortsPriorizedGetCollectionResponse["hydra:member"]
      >(
        payload,
        async () => {
          const promise =
            (await apiEffortsPriorizedGetCollection<ThrowGlobalError>({
              ...payload,
              ...(options?.context
                ? { query: { context: options?.context } }
                : {}),
              throwOnError: options.throwGlobalError,
            })) as AxiosResponse<
              ApiEffortsPriorizedGetCollectionResponse["hydra:member"]
            >;
          if (!(promise.status >= 200 && promise.status < 300))
            throw new Error("ERROR_SKIP_CACHE", { cause: promise });
          return promise.data["hydra:member"]
            ? Array.from(promise.data["hydra:member"])
            : [];
        },
        "collection",
      );
      if (typeof res.value === "object" && !payload.query["properties[]"]) {
        const data =
          res.value as ApiEffortsPriorizedGetCollectionResponse["hydra:member"];
        await Promise.all(
          data.map((jsonld) => {
            if (jsonld["@id"]) {
              return this.$cache.set(iri2id(jsonld["@id"]), jsonld, "item");
            }
          }),
        );
      }
      return res as Ref<
        ApiEffortsPriorizedGetCollectionResponse["hydra:member"]
      >;
    },
    async findAllPriorizedHydra<ThrowGlobalError extends boolean = true>(
      payload: ApiEffortsPriorizedGetCollectionData | null,
      options?: RequestOptions<ThrowGlobalError>,
    ): Promise<Ref<ApiEffortsPriorizedGetCollectionResponse>> {
      payload ??= {};
      payload.query ??= {};
      payload.query.page ??= 1;
      payload.query.itemsPerPage ??= 100;
      if (options?.context) payload.query.context = options.context;
      if (options?.forceRefresh) await this.$cache.delete(payload, "hydra");
      const res =
        await this.$cache.getOrCreate<ApiEffortsPriorizedGetCollectionResponse>(
          payload,
          async () => {
            const d = await apiEffortsPriorizedGetCollection<ThrowGlobalError>(
              payload,
            ).then((d) => d.data);
            return d;
          },
          "hydra",
        );
      if (typeof res.value === "object" && !payload.query["properties[]"]) {
        const data = res.value["hydra:member"];
        await Promise.all(
          data.map((jsonld) => {
            if (jsonld["@id"]) {
              return this.$cache.set(iri2id(jsonld["@id"]), jsonld, "item");
            }
          }),
        );
      }
      return res;
    },
    async findPriorized<ThrowGlobalError extends boolean = true>(
      payload: ApiEffortsPriorizedGetCollectionData,
      options?: RequestOptions<ThrowGlobalError>,
    ) {
      options = storeMethodArgumentsCompatibilityLayer(arguments, "find");
      if (!payload) payload = { query: {} };
      if (!payload.query) payload.query = {};
      payload.query.page = 1;
      payload.query.itemsPerPage = 1;
      if (options?.context) payload.query.context = options.context;
      const res = await this.findAll<ThrowGlobalError>(payload, options);
      if (res.value.length > 1)
        logger.warn("Find() returned more than one result!");
      return computed(() => (res.value.length > 0 ? res.value[0] : undefined));
    },
    /* {"name":"apiEffortsPriorizedGetCollection","tag":"Effort","storeName":"Effort","requestType":"ApiEffortsPriorizedGetCollectionData","responseType":"ApiEffortsPriorizedGetCollectionResponse","errorType":"unknown","apiFunctionName":"apiEffortsPriorizedGetCollection","requestImportName":"ApiEffortsPriorizedGetCollectionData","responseImportName":"ApiEffortsPriorizedGetCollectionResponse","actionType":"collection","actionName":"fetchAll","friendlyName":"fetchAll","suffix":"Priorized"} */
    async findAllPriorizedWithPagination<
      ThrowGlobalError extends boolean = true,
    >(
      payload: ApiEffortsPriorizedGetCollectionData | null,
      options?: RequestOptions<ThrowGlobalError>,
    ) {
      options = storeMethodArgumentsCompatibilityLayer(
        arguments,
        "findAllWithPagination",
      );
      const result = await this.findAllPriorizedHydra<ThrowGlobalError>(
        payload,
        options,
      );
      return HydraToPagination<(typeof result.value)["hydra:member"][number]>(
        result,
      );
    },
    async findAllPriorizedAsIriDictionary<
      ThrowGlobalError extends boolean = true,
    >(
      payload: ApiEffortsPriorizedGetCollectionData | null,
      options?: RequestOptions<ThrowGlobalError>,
    ) {
      options = storeMethodArgumentsCompatibilityLayer(
        arguments,
        "findAllAsIriDictionary",
      );
      const result = await this.findAllPriorizedHydra<ThrowGlobalError>(
        payload,
        options,
      );
      return HydraToIriDictionary<
        (typeof result.value)["hydra:member"][number]
      >(result);
    },
    async findAllPriorizedAsMap<ThrowGlobalError extends boolean = true>(
      payload: ApiEffortsPriorizedGetCollectionData | null,
      options?: RequestOptions<ThrowGlobalError>,
    ) {
      options = storeMethodArgumentsCompatibilityLayer(
        arguments,
        "findAllAsMap",
      );
      const result = await this.findAllPriorizedHydra<ThrowGlobalError>(
        payload,
        options,
      );
      return HydraToIriMap<(typeof result.value)["hydra:member"][number]>(
        result,
      );
    },
    /**
{"name":"apiEffortsUnsyncedGetCollection","tag":"Effort","storeName":"Effort","requestType":"ApiEffortsUnsyncedGetCollectionData","responseType":"ApiEffortsUnsyncedGetCollectionResponse","errorType":"unknown","apiFunctionName":"apiEffortsUnsyncedGetCollection","requestImportName":"ApiEffortsUnsyncedGetCollectionData","responseImportName":"ApiEffortsUnsyncedGetCollectionResponse","actionType":"collection","actionName":"fetchAll","friendlyName":"fetchAll","suffix":"Unsynced"}
*/
    async findAllUnsynced<ThrowGlobalError extends boolean = true>(
      payload: ApiEffortsUnsyncedGetCollectionData | null,
      options?: RequestOptions<ThrowGlobalError>,
    ): Promise<Ref<ApiEffortsUnsyncedGetCollectionResponse["hydra:member"]>> {
      options = storeMethodArgumentsCompatibilityLayer(arguments, "findAll");
      options = defaultRequestOptionsMerge(options);
      payload ??= {};
      payload.query ??= {};
      payload.query.page ??= 1;
      payload.query.itemsPerPage ??= 100;
      if (payload.query.itemsPerPage === 0) return ref([]);
      if (options?.context) payload.query.context = options.context;
      if (options?.forceRefresh)
        await this.$cache.delete(payload, "collection");
      const res = await this.$cache.getOrCreate<
        ApiEffortsUnsyncedGetCollectionResponse["hydra:member"]
      >(
        payload,
        async () => {
          const promise =
            (await apiEffortsUnsyncedGetCollection<ThrowGlobalError>({
              ...payload,
              ...(options?.context
                ? { query: { context: options?.context } }
                : {}),
              throwOnError: options.throwGlobalError,
            })) as AxiosResponse<
              ApiEffortsUnsyncedGetCollectionResponse["hydra:member"]
            >;
          if (!(promise.status >= 200 && promise.status < 300))
            throw new Error("ERROR_SKIP_CACHE", { cause: promise });
          return promise.data["hydra:member"]
            ? Array.from(promise.data["hydra:member"])
            : [];
        },
        "collection",
      );
      if (typeof res.value === "object" && !payload.query["properties[]"]) {
        const data =
          res.value as ApiEffortsUnsyncedGetCollectionResponse["hydra:member"];
        await Promise.all(
          data.map((jsonld) => {
            if (jsonld["@id"]) {
              return this.$cache.set(iri2id(jsonld["@id"]), jsonld, "item");
            }
          }),
        );
      }
      return res as Ref<
        ApiEffortsUnsyncedGetCollectionResponse["hydra:member"]
      >;
    },
    async findAllUnsyncedHydra<ThrowGlobalError extends boolean = true>(
      payload: ApiEffortsUnsyncedGetCollectionData | null,
      options?: RequestOptions<ThrowGlobalError>,
    ): Promise<Ref<ApiEffortsUnsyncedGetCollectionResponse>> {
      payload ??= {};
      payload.query ??= {};
      payload.query.page ??= 1;
      payload.query.itemsPerPage ??= 100;
      if (options?.context) payload.query.context = options.context;
      if (options?.forceRefresh) await this.$cache.delete(payload, "hydra");
      const res =
        await this.$cache.getOrCreate<ApiEffortsUnsyncedGetCollectionResponse>(
          payload,
          async () => {
            const d = await apiEffortsUnsyncedGetCollection<ThrowGlobalError>(
              payload,
            ).then((d) => d.data);
            return d;
          },
          "hydra",
        );
      if (typeof res.value === "object" && !payload.query["properties[]"]) {
        const data = res.value["hydra:member"];
        await Promise.all(
          data.map((jsonld) => {
            if (jsonld["@id"]) {
              return this.$cache.set(iri2id(jsonld["@id"]), jsonld, "item");
            }
          }),
        );
      }
      return res;
    },
    async findUnsynced<ThrowGlobalError extends boolean = true>(
      payload: ApiEffortsUnsyncedGetCollectionData,
      options?: RequestOptions<ThrowGlobalError>,
    ) {
      options = storeMethodArgumentsCompatibilityLayer(arguments, "find");
      if (!payload) payload = { query: {} };
      if (!payload.query) payload.query = {};
      payload.query.page = 1;
      payload.query.itemsPerPage = 1;
      if (options?.context) payload.query.context = options.context;
      const res = await this.findAll<ThrowGlobalError>(payload, options);
      if (res.value.length > 1)
        logger.warn("Find() returned more than one result!");
      return computed(() => (res.value.length > 0 ? res.value[0] : undefined));
    },
    /* {"name":"apiEffortsUnsyncedGetCollection","tag":"Effort","storeName":"Effort","requestType":"ApiEffortsUnsyncedGetCollectionData","responseType":"ApiEffortsUnsyncedGetCollectionResponse","errorType":"unknown","apiFunctionName":"apiEffortsUnsyncedGetCollection","requestImportName":"ApiEffortsUnsyncedGetCollectionData","responseImportName":"ApiEffortsUnsyncedGetCollectionResponse","actionType":"collection","actionName":"fetchAll","friendlyName":"fetchAll","suffix":"Unsynced"} */
    async findAllUnsyncedWithPagination<
      ThrowGlobalError extends boolean = true,
    >(
      payload: ApiEffortsUnsyncedGetCollectionData | null,
      options?: RequestOptions<ThrowGlobalError>,
    ) {
      options = storeMethodArgumentsCompatibilityLayer(
        arguments,
        "findAllWithPagination",
      );
      const result = await this.findAllUnsyncedHydra<ThrowGlobalError>(
        payload,
        options,
      );
      return HydraToPagination<(typeof result.value)["hydra:member"][number]>(
        result,
      );
    },
    async findAllUnsyncedAsIriDictionary<
      ThrowGlobalError extends boolean = true,
    >(
      payload: ApiEffortsUnsyncedGetCollectionData | null,
      options?: RequestOptions<ThrowGlobalError>,
    ) {
      options = storeMethodArgumentsCompatibilityLayer(
        arguments,
        "findAllAsIriDictionary",
      );
      const result = await this.findAllUnsyncedHydra<ThrowGlobalError>(
        payload,
        options,
      );
      return HydraToIriDictionary<
        (typeof result.value)["hydra:member"][number]
      >(result);
    },
    async findAllUnsyncedAsMap<ThrowGlobalError extends boolean = true>(
      payload: ApiEffortsUnsyncedGetCollectionData | null,
      options?: RequestOptions<ThrowGlobalError>,
    ) {
      options = storeMethodArgumentsCompatibilityLayer(
        arguments,
        "findAllAsMap",
      );
      const result = await this.findAllUnsyncedHydra<ThrowGlobalError>(
        payload,
        options,
      );
      return HydraToIriMap<(typeof result.value)["hydra:member"][number]>(
        result,
      );
    },

    async fetchAllByIri<ThrowGlobalError extends boolean = true>(
      iris: string[],
      options?: RequestOptions<ThrowGlobalError>,
    ) {
      options = storeMethodArgumentsCompatibilityLayer(
        arguments,
        "fetchAllByIri",
      );
      const result: Ref<unknown[]> = ref([]);
      const iriCheck = checkIriArray(iris, this.$iriPrefix);
      if (iriCheck.inputCnt != iriCheck.outputCnt)
        logger.warn(
          `At least one given iri is not valid or does not match api prefix (${this.$iriPrefix})!`,
          iris,
        );
      if (iriCheck.outputCnt == 0) return result;
      const allIds = iriCheck.iris.map((iri) => fromIri<string>(iri)?.id!);
      const dataset = options?.forceRefresh
        ? allIds.map((id) => [id, undefined])
        : await Promise.all(
            allIds.map(async (id) => [id, await this.$cache.get(id, "item")]),
          );
      const missingInCache = dataset
        .filter((pair) => !pair[1])
        .map((pair) => pair[0]);
      const fetched = await this.findAll<ThrowGlobalError>(
        {
          query: {
            itemsPerPage: missingInCache.length,
            "id[]": missingInCache as string[],
          },
        },
        options,
      ).then((d) => d.value);
      //now rebuild return
      for (const id of allIds) {
        const dsMatch = dataset.find((pair) => pair[0] == id) as unknown[];
        if (dsMatch[1]) {
          result.value.push(dsMatch[1]);
          continue;
        }
        if (fetched && fetched.length > 0) {
          /*
           */
          const fetchedItem = fetched.find(
            (itm) => (itm.id as string) == (id as string),
          );
          if (!fetchedItem) {
            debugger;
          }
          result.value.push(fetchedItem);
        }
      }
      return result;
    },

    async fetchAllByIriAsDictionary<ThrowGlobalError extends boolean = true>(
      iris: string[],
      options?: RequestOptions<ThrowGlobalError>,
    ) {
      options = storeMethodArgumentsCompatibilityLayer(
        arguments,
        "fetchAllByIriAsDictionary",
      );
      const data = await this.fetchAllByIri<ThrowGlobalError>(iris, options);
      const res = keyBy(
        data.value,
        (e: ApiEffortsIdGetResponse) => e["@id"],
      ) as Record<string, ApiEffortsIdGetResponse>;
      return readonly(ref(res));
    },
    async fetchAllByIriAsMap<ThrowGlobalError extends boolean = true>(
      iris: string[],
      options?: RequestOptions<ThrowGlobalError>,
    ) {
      options = storeMethodArgumentsCompatibilityLayer(
        arguments,
        "fetchAllByIriAsMap",
      );
      const result = new Map<string, ApiEffortsIdGetResponse>();
      const rawData = await this.fetchAllByIri<ThrowGlobalError>(iris, options);
      const data = keyBy(
        rawData.value,
        (e: ApiEffortsIdGetResponse) => e["@id"],
      ) as Record<string, ApiEffortsIdGetResponse>;
      forEach(data, (v: ApiEffortsIdGetResponse, k: string) =>
        result.set(k, v),
      );
      return readonly(ref(result));
    },

    /* {"name":"apiEffortsPost","tag":"Effort","storeName":"Effort","requestType":"ApiEffortsPostData","responseType":"ApiEffortsPostResponse","errorType":"ApiEffortsPostError","apiFunctionName":"apiEffortsPost","requestImportName":"ApiEffortsPostData","responseImportName":"ApiEffortsPostResponse","actionType":"post","actionName":"post","friendlyName":"post","suffix":""} */
    async post<ThrowGlobalError extends boolean = true>(
      payload: ApiEffortsPostData,
      options?: RequestOptions<ThrowGlobalError>,
    ) {
      options = storeMethodArgumentsCompatibilityLayer(arguments, "post");
      options = defaultRequestOptionsMerge(options);
      return await apiEffortsPost<ThrowGlobalError>({
        ...payload,
        throwOnError: options.throwGlobalError,
      }).then((d) => d.data);
    },

    /* {"name":"apiEffortsIdPut","tag":"Effort","storeName":"Effort","requestType":"ApiEffortsIdPutData","responseType":"ApiEffortsIdPutResponse","errorType":"ApiEffortsIdPutError","apiFunctionName":"apiEffortsIdPut","requestImportName":"ApiEffortsIdPutData","responseImportName":"ApiEffortsIdPutResponse","actionType":"update","actionName":"put","friendlyName":"put","identifierName":"id","identifierType":"string","suffix":"Id","identifierNameCapitalized":"Id"} */
    async putId<ThrowGlobalError extends boolean = true>(
      payload: ApiEffortsIdPutData,
      options?: RequestOptions<ThrowGlobalError>,
    ) {
      options = storeMethodArgumentsCompatibilityLayer(arguments, "put");
      options = defaultRequestOptionsMerge(options);
      if (isIri(payload.path.id)) {
        payload.path.id = iri2id(payload.path.id);
        console.log("IRI given where Id was expected! Please fix!");
      }
      return await apiEffortsIdPut<ThrowGlobalError>({
        ...payload,
        throwOnError: options.throwGlobalError,
      }).then((d) => d.data);
    },

    async delete<ThrowGlobalError extends boolean = true>(
      payload: ApiEffortsIdDeleteData,
      options?: RequestOptions<ThrowGlobalError>,
    ) {
      options = storeMethodArgumentsCompatibilityLayer(arguments, "delete");
      options = defaultRequestOptionsMerge(options);
      const res = await apiEffortsIdDelete<ThrowGlobalError>({
        ...payload,
        throwOnError: options.throwGlobalError,
      });
      await this.$cache.delete(payload, "item");
      return res;
    },
  },
});
